import {initializeApp} from 'firebase/app';
import {getAnalytics} from 'firebase/analytics';
import { getUserCredentials } from '@meprism/shared/src/services/AuthenticationService';
import { getAdAttributes } from './helpers';
const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

declare global {
  interface Window {
    gtag: (...args: any[]) => void;
  }
}

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Analytics
export const analytics = getAnalytics(app);

// Function to log events
export const logFirebaseEvent = async (
  eventName: string,
  eventParams?: Record<string, any>
) => {
  try {
    const credentials = await getUserCredentials();
    const adAttributes = getAdAttributes()
    const eventProps = {
      ...credentials,
      ...adAttributes,
      ...(eventParams || {}),
      ...(credentials.muid ? { "user_id": credentials.muid } : {})
    };

    if (window.gtag) {
        window.gtag('event', eventName, eventProps);
    }
  } catch (error) {
    console.error("Error logging Firebase event:", error);
  }
};